import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import logo from "../public/assets/images/logo.jpg"; // adjust path based on file location

const Navbar = () => {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
      if (window.innerWidth >= 768) setMobileMenuOpen(false);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const navStyle = {
    position: "fixed",
    top: 0,
    width: "100%",
    backgroundColor: "rgba(5, 7, 10, 0.95)",
    backdropFilter: "blur(12px)",
    borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
    zIndex: 1000,
  };

  const containerStyle = {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "12px 20px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  };

  const logoStyle = {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    textDecoration: "none",
    color: "#ffffff",
    fontWeight: "900",
    fontSize: "1.25rem",
  };

  const linkStyle = {
    marginLeft: isMobile ? "0" : "25px",
    textDecoration: "none",
    color: "#a0aab4",
    fontSize: "1rem",
    fontWeight: "600",
    padding: isMobile ? "15px 0" : "0",
    transition: "0.3s ease",
  };

  return (
    <nav style={navStyle}>
      <div style={containerStyle}>
        {/* LOGO */}
        <Link to="/" style={logoStyle} onClick={() => setMobileMenuOpen(false)}>
          <img
  src={logo}
  alt="Digital X AI Logo"
  style={{ height: "58px", width: "auto", borderRadius: "4px" }}
/>
           
        </Link>

        {/* HAMBURGER ICON FOR MOBILE */}
        {isMobile && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              cursor: "pointer",
              gap: "5px",
              zIndex: 1001,
            }}
            onClick={() => setMobileMenuOpen(!isMobileMenuOpen)}
          >
            <div
              style={{
                height: "3px",
                width: "28px",
                backgroundColor: "#00d4ff",
                borderRadius: "2px",
                transform: isMobileMenuOpen ? "rotate(45deg) translate(6px, 6px)" : "none",
                transition: "0.3s",
              }}
            ></div>
            <div
              style={{
                height: "3px",
                width: "28px",
                backgroundColor: "#00d4ff",
                borderRadius: "2px",
                opacity: isMobileMenuOpen ? 0 : 1,
                transition: "0.3s",
              }}
            ></div>
            <div
              style={{
                height: "3px",
                width: "28px",
                backgroundColor: "#00d4ff",
                borderRadius: "2px",
                transform: isMobileMenuOpen ? "rotate(-45deg) translate(5px, -6px)" : "none",
                transition: "0.3s",
              }}
            ></div>
          </div>
        )}

        {/* DESKTOP MENU */}
        {!isMobile && (
          <div style={{ display: "flex", alignItems: "center" }}>
            <Link to="/" style={linkStyle}>Home</Link>
            <Link to="/resources" style={linkStyle}>Resources</Link>
            <Link to="/artificial-intelligence" style={linkStyle}>AI Solutions</Link>
            <Link to="/strategy" style={linkStyle}>Strategy</Link>
            <Link to="/about" style={linkStyle}>About</Link>
            <Link
              to="/contact"
              style={{
                ...linkStyle,
                color: "#00d4ff",
                border: "1px solid #00d4ff",
                padding: "8px 22px",
                borderRadius: "50px",
                marginLeft: "30px",
              }}
            >
              Contact
            </Link>
          </div>
        )}

        {/* MOBILE MENU */}
        {isMobile && isMobileMenuOpen && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              backgroundColor: "#05070a",
              position: "absolute",
              top: "100%",
              left: 0,
              width: "100%",
              padding: "20px",
              borderBottom: "1px solid rgba(0, 212, 255, 0.2)",
            }}
          >
            <Link to="/" style={linkStyle} onClick={() => setMobileMenuOpen(false)}>Home</Link>
            <Link to="/resources" style={linkStyle} onClick={() => setMobileMenuOpen(false)}>Resources</Link>
            <Link to="/artificial-intelligence" style={linkStyle} onClick={() => setMobileMenuOpen(false)}>AI Solutions</Link>
            <Link to="/strategy" style={linkStyle} onClick={() => setMobileMenuOpen(false)}>Strategy</Link>
            <Link to="/about" style={linkStyle} onClick={() => setMobileMenuOpen(false)}>About</Link>
            <Link
              to="/contact"
              style={{
                ...linkStyle,
                color: "#05070a",
                background: "#00d4ff",
                textAlign: "center",
                padding: "12px",
                borderRadius: "10px",
                marginTop: "10px",
              }}
              onClick={() => setMobileMenuOpen(false)}
            >
              Contact Us
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;